export default {
    edit: 'Uredi',
    location: 'Lokacija + Uvjeti i odredbe',
    filter: 'Filter',
};
